import config from 'src/config/config';
import api from 'src/api/interceptor';

export function createOutwardVehicleTrackingApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/create-outward-vehicle-tracking/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function createDuplicateVehicleTrackingApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/create-duplicate-vehicle-tracking/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function validateAndGetDuplicateObjectsForVehicleTrackingApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/validate-and-get-duplicate-objects-for-vehicle-tracking/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getAttachedDeliveryForOutwardVehicleApi(
  tenantOrganisationId,
  vehicleId,
  todayDate,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-attached-delivery-for-outward-vehicle/?tenant_organisation_id=${tenantOrganisationId}&vehicle_id=${vehicleId}&delivery_date=${todayDate}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getVehicleDetailsForOutwardApi(
  tenantOrganisationId,
  vehicleId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-details/?tenant_organisation_id=${tenantOrganisationId}&vehicle_id=${vehicleId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getVehicleDetailsApi(tenantOrganisationId, vehicleId) {
  return api
    .get(`${config.test_url}api/vehicle-tracking/get-vehicle-details/`, {
      params: {
        tenant_organisation_id: tenantOrganisationId,
        vehicle_id: vehicleId,
      },
    })
    .then((res) => Promise.resolve(res));
}

export function getVehicleTrackingsForVehicleDetailApi(
  tenantOrganisationId,
  vehicleId,
  vehicleTrackingStatus,
  pageNumber,
  paginationBatchSize,
  filters = {},
) {
  const params = {
    tenant_organisation_id: tenantOrganisationId,
    vehicle_id: vehicleId,
    status: vehicleTrackingStatus,
    page_number: pageNumber,
    pagination_batch_size: paginationBatchSize,
  };

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      params[key] = value;
    }
  });

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-trackings-for-vehicle-detail/`,
      {
        params,
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getVehicleDropdownOptionsApi(
  tenantOrganisationId,
  vehicleSearchTerm,
  transporterId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-dropdown-options/`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          search_term: vehicleSearchTerm,
          transporter_id: transporterId,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getDeliveryForBusinessPartnerApi(searchData) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-delivery-list-for-business-partner/`,
      {
        params: searchData,
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getDeliveryDropdownOptionsApi(
  tenantOrganisationId,
  vehicleNumber,
  pageNumber,
  paginationBatchSize,
  deliveryStartDate,
  deliveryEndDate,
  productSapCode,
  searchTerm,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-delivery-dropdown-options/`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          vehicle_number: vehicleNumber,
          page_number: pageNumber,
          pagination_batch_size: paginationBatchSize,
          delivery_start_date: deliveryStartDate,
          delivery_end_date: deliveryEndDate,
          product_sap_code: productSapCode,
          search_term: searchTerm,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getCategoryBusinessPartnersDropdownOptionsApi(
  tenantOrganisationId,
  searchTerm,
  categoryKeyId,
) {
  return api
    .get(
      `${config.test_url}api/core/get-business-partners-dropdown-options/?tenant_organisation_id=${tenantOrganisationId}&search_term=${searchTerm}&category_key_id=${categoryKeyId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getTransportersDropdownOptionsApi(
  tenantOrganisationId,
  searchTerm,
) {
  // 23 for Logistics Partner
  const categoryKeyId = '23';
  return api
    .get(
      `${config.test_url}api/core/get-business-partners-dropdown-options/?tenant_organisation_id=${tenantOrganisationId}&search_term=${searchTerm}&category_key_id=${categoryKeyId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getTransporterDropdownOptionsApi(
  tenantOrganisationId,
  searchTerm,
  vehicleId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-transporter-dropdown-options/`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          search_term: searchTerm,
          vehicle_id: vehicleId,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getVehicleTrackingListForPlanningApi(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  paginationBatchSize,
  queryString,
) {
  const searchFieldFilterList = new URLSearchParams(queryString).toString();

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-tracking-list-for-planning/?${searchFieldFilterList}`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          page_number: pageNumber,
          search_term: searchInput,
          pagination_batch_size: paginationBatchSize,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getOutwardVehicleTrackingDetailsApi(
  vehicleTrackingNumber,
  tenantOrganisationId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-outward-vehicle-tracking-details/?vehicle_tracking_number=${vehicleTrackingNumber}&tenant_organisation_id=${tenantOrganisationId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function updateVehicleTrackingForOutwardApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/update-vehicle-tracking-for-planning/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getPackTypeForDeliveryLineItemApi(
  tenantOrganisationId,
  deliveryLineItemId,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-pack-type-for-delivery-line-item/?delivery_line_item_id=${deliveryLineItemId}&tenant_organisation_id=${tenantOrganisationId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function createVehicleTrackingLoadHeaderApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/create-vehicle-tracking-load-header/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getVehicleTrackingAttachedLoadsApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-tracking-attached-loads/?vehicle_tracking_number=${vehicleTrackingNumber}&tenant_organisation_id=${tenantOrganisationId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getLoadLineItemsForLoadHeaderApi(
  tenantOrganisationId,
  vtLoadHeaderUniqueNumber,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-load-line-items-for-load-header/?vt_load_header_unique_number=${vtLoadHeaderUniqueNumber}&tenant_organisation_id=${tenantOrganisationId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function updateVehicleTrackingLoadLineItemApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/update-vehicle-tracking-load-line-item/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function updateVehicleTrackingLoadApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/update-vehicle-tracking-load/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getDataForVehicleTrackingLoadCardsApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
  vtLoadHeaderUniqueNumber,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-data-for-vehicle-tracking-load-cards/?vehicle_tracking_number=${vehicleTrackingNumber}&tenant_organisation_id=${tenantOrganisationId}&vt_load_header_unique_number=${vtLoadHeaderUniqueNumber}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getCapturedWeightForWeightBridgeEventUuidApi(
  tenantOrganisationId,
  vtLoadHeaderUniqueNumber,
  weightBridgeEventUUID,
  vehicleTrackingNumber,
  fieldVerboseName,
) {
  const params = {
    tenant_organisation_id: tenantOrganisationId,
    vt_load_header_unique_number: vtLoadHeaderUniqueNumber,
    weight_bridge_event_uuid: weightBridgeEventUUID,
    vehicle_tracking_number: vehicleTrackingNumber,
    field_verbose_name: fieldVerboseName,
  };
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-captured-weight-for-weight-bridge-event-uuid/?`,
      { params },
    )
    .then((res) => Promise.resolve(res));
}

export function updateVehicleTrackingLoadWeightApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/update-vehicle-tracking-load-weight/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function confirmVehicleTrackingLoadApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/confirm-vehicle-tracking-load/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getLoadLineItemsForVehicleTrackingApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-load-line-items-for-vehicle-tracking/?tenant_organisation_id=${tenantOrganisationId}&vehicle_tracking_number=${vehicleTrackingNumber}`,
    )
    .then((res) => Promise.resolve(res));
}

export function updateVehicleTrackingOnHoldApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/update-vehicle-tracking-on-hold/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getAttachedDeliveriesForVehicleTrackingApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  const params = {
    tenant_organisation_id: tenantOrganisationId,
    vehicle_tracking_number: vehicleTrackingNumber,
  };
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-attached-deliveries-for-vehicle-tracking/?`,
      { params },
    )
    .then((res) => Promise.resolve(res));
}

export function getAttachedDeliveryLineItemsForVehicleTrackingApi(
  tenantOrganisationId,
  vehicleTrackingNumber,
  productId,
  businessPartnerId,
) {
  const params = {
    tenant_organisation_id: tenantOrganisationId,
    vehicle_tracking_number: vehicleTrackingNumber,
  };

  if (productId) {
    params.product_id = productId;
  }

  if (businessPartnerId) {
    params.business_partner_id = businessPartnerId;
  }

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-attached-delivery-line-items-for-vehicle-tracking/?`,
      { params },
    )
    .then((res) => Promise.resolve(res));
}

export function updateVehicleTrackingDeliveryAttachmentsApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/update-vehicle-tracking-delivery-attachments/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getProductsApi(tenantOrganisationId, searchTerm) {
  return api
    .get(
      `${config.test_url}api/material/get-products/?tenant_organisation_id=${tenantOrganisationId}${searchTerm ? `&search_term=${searchTerm}` : ''}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getOutwardReportWithExitTimeApi(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  paginationBatchSize,
  queryString,
) {
  const params = new URLSearchParams(queryString);

  tableFieldFilter?.forEach((fieldId) => params.append('field_id', fieldId));

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-outward-report-with-exit-time/?${params.toString()}`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          page_number: pageNumber,
          sort_order: tableSortOrder,
          sort_field: tableSortField,
          pagination_batch_size: paginationBatchSize,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function updateVehicleTrackingDetailsApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/update-vehicle-tracking-details/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getVarianceReportForOutwardApi(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  paginationBatchSize,
  queryString,
) {
  const params = new URLSearchParams(queryString);

  tableFieldFilter?.forEach((fieldId) => params.append('field_id', fieldId));

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-variance-report-for-outward/?${params.toString()}`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          page_number: pageNumber,
          sort_order: tableSortOrder,
          sort_field: tableSortField,
          pagination_batch_size: paginationBatchSize,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function updateVehicleTrackingStatusApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/update-vehicle-tracking-status/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getReasonsDropdownOptionsForVehicleTrackingApi(
  tenantOrganisationId,
  documentType,
) {
  const params = {
    tenant_organisation_id: tenantOrganisationId,
    document_type: documentType,
  };
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-reasons-dropdown-options-for-vehicle-tracking/?`,
      { params },
    )
    .then((res) => Promise.resolve(res));
}
